/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuditLogDto } from '../../models/audit-log-dto';

export interface GetAuditLog$Params {
  id: string;
}

export function getAuditLog(http: HttpClient, rootUrl: string, params: GetAuditLog$Params, context?: HttpContext): Observable<StrictHttpResponse<AuditLogDto>> {
  const rb = new RequestBuilder(rootUrl, getAuditLog.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuditLogDto>;
    })
  );
}

getAuditLog.PATH = '/v0/auditLogs/{id}';
